import styled from '@emotion/styled';
import { responseFont } from '@landsbankinn/ui';
import React, { useState } from 'react';
import { animated, useSpring } from 'react-spring';

const BottomLine = styled.div`
  position: relative;
  width: 40px;
  height: 10px;
  overflow: hidden;
  &:before {
    display: block;
    content: '';
    background-color: ${(props) => props.theme.shades.primary1};
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 5px;
  }
  > div {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    top: 5px;
    background-color: ${(props) => props.theme.colors.primary};
  }
`;

const NavItem = styled(animated.a)`
  display: block;
  position: relative;
  width: 100%;
  height: 75px;
  line-height: 60px;
  color: #1e3d5a;
  font-family: ${(props) => props.theme.font.familySerifCond};
  font-size: 36px;
  font-weight: 500;
  will-change: transform, opacity;
  overflow: hidden;
  text-decoration: none;

  &:nth-child(1) {
    ${BottomLine} {
      > div {
        background-color: ${(props) => props.theme.colors.primary};
      }
    }
  }

  &:nth-child(2) {
    ${BottomLine} {
      > div {
        background-color: ${(props) => props.theme.shades.secondary4};
      }
    }
  }
  &:nth-child(3) {
    ${BottomLine} {
      > div {
        background-color: ${(props) => props.theme.shades.primary3};
      }
    }
  }
  &:nth-child(4) {
    ${BottomLine} {
      > div {
        background-color: ${(props) => props.theme.shades.ternary4};
      }
    }
  }
  &:nth-child(5) {
    ${BottomLine} {
      > div {
        background-color: ${(props) => props.theme.shades.secondary3};
      }
    }
  }

  &:nth-child(6) {
    ${BottomLine} {
      > div {
        background-color: ${(props) => props.theme.shades.primary2};
      }
    }
  }

  @media (min-height: 800px) {
    height: 80px;
    line-height: 65px;
  }

  @media (min-height: 900px) {
    ${responseFont(28, 46)}
    height: 100px;
  }

  @media (min-height: 961px) {
    ${responseFont(32, 52)}
    height: 100px;
  }
`;

const ArrowSvg = styled.svg<any>`
  margin-left: 32px;
  margin-bottom: 1px;
  width: 13px;
  transform: ${(props) =>
    props.selected ? `translateX(0px)` : 'translateX(-5px)'};
  opacity: ${(props) => (props.selected ? 1 : 0)};
  transition: 220ms ease-in-out;
  transition-property: transform, opacity;
`;

const Arrow = ({ selected }: any) => (
  <ArrowSvg viewBox="0 0 9 17" version="1.1" selected={selected}>
    <g
      transform="translate(-479.000000, -213.000000)"
      stroke="#1E3C5A"
      strokeWidth="3"
    >
      <polyline points="481 214 486 221.5 481 229" fill="white" />
    </g>
  </ArrowSvg>
);

export const SecondLevelItem = (props: any) => {
  const [hover, setHover] = useState(false);
  const { height, item, selected, style } = props;
  const p = useSpring({
    x: hover || selected ? '0%' : '-100%',
    y: hover || selected ? 1 : 0,
    reset: hover || selected,
    from: { x: '-100%' },
  });

  return (
    <NavItem
      href="#"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onFocus={() => {
        const focusWithMouse =
          typeof window !== 'undefined' &&
          document.body.classList.contains('focus-with-mouse');
        if (!focusWithMouse) {
          setHover(true);
        }
      }}
      onBlur={() => setHover(false)}
      onClick={(e: any) => {
        e.preventDefault();
        if (props.onSelect) {
          props.onSelect(item);
        }
        return false;
      }}
      style={style}
    >
      <animated.div style={{ height, overflow: 'hidden' }}>
        {item.primary.link_text}
        <Arrow selected={selected} />
      </animated.div>
      <BottomLine>
        <animated.div
          style={{
            /*             opacity: p.y, */
            transform: selected
              ? undefined
              : p.x.to((x) => `translate3d(${x},0,0)`),
          }}
        />
      </BottomLine>
    </NavItem>
  );
};
